import React from 'react';
import Loader from '../Loader';

class Page extends React.Component {
  render() {
    const { className, children, loading = false } = this.props;
    const loadingStyle = {
      height: 'calc(100vh - 184px)',
      overflow: 'hidden',
    };
    return (
      <div className={className} style={loading ? loadingStyle : null}>
        {loading ? <Loader spinning /> : ''}
        {children}
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page/Page.js